module.exports = __webpack_public_path__ + "static/media/bytt-no-13.4d3db051.mp3";